import React, { useEffect, useState } from "react";
import { Card, Row, Col, Table, Typography, Divider } from "antd";
import { numberFormat, convertNumberToWords, formatToCompanyTimezone } from "../../../../../lib/functions";
import { purchaseReturnWithDetailsApi } from "../../../../../apiservice/purchase";
import "./voucher-mobile.css"
import { useSelector } from "react-redux";
import { selectAuthInfo } from "../../../../Auth/authSelectors";
import Big from "big.js";

const { Title, Text } = Typography;

const PurchaseReturnVoucherBody = ({ pur_r_id, institution, printMode = false, showStamp = false, showSignature = false, setVoucherNo, setAccName, setSupplierEmail }) => {
  const [data, setData] = useState(null);
  console.log('data:', data);
  const authInfo = useSelector(selectAuthInfo);
  const isIndia = authInfo?.country?.toLowerCase() === "india";
  const isIndiaGst = authInfo?.gst_enabled === "yes";
  const taxLabel = isIndia ? "GST" : "VAT";
  const totalTax = Number(data?.total_tax || 0);
  const cgst = isIndia ? totalTax / 2 : 0;
  const sgst = isIndia ? totalTax / 2 : 0;
  console.log(isIndiaGst, "isIndiaGst");
  const isGSTDisabled =
    isIndia && authInfo?.gst_enabled == "no";
    
  useEffect(() => {
    if (!pur_r_id) return;
    purchaseReturnWithDetailsApi({ pur_r_id, from: "voucher" }).then((res) => {
      if (res?.data?.length) {
        const record = res.data[0];
        setData(record);
        // important guard for printMode
        if (!printMode && setVoucherNo) {
          setVoucherNo(record.pur_r_voucher_no);
          setAccName(record.acc_name)
        }

        if (record.email_address) {
          setSupplierEmail?.(record.email_address);
        }
      }
    });
  }, [pur_r_id]);

  if (!data) return null;

  const isIndividual = data.is_cal_type === "individual";
  const items = (data.details || []).map(item => ({
    ...item,
    qty_display:
      item?.pur_r_qty +
      " " +
      item?.unit_symbol +
      (item?.conversion > 1
        ? ", " + item?.retail_qty + " " + item?.base_unit_name
        : ""),
    // done_qty_display :
    //           item?.done_item_qty +
    //           " " +
    //           item?.unit_symbol +
    //           (item?.conversion > 1
    //             ? ", " + item?.done_retail_qty + " " + item?.base_unit_name
    //             : ""),
  }))



  // calculate grand total
  const grandTotal = isIndividual
    ? items.reduce((sum, d) => {
      let qty = d.pur_r_qty || 0;
      let rate = Number(d.pur_r_rate || 0);
      let total = qty * rate;
      total -= (Number(d.item_discount_per) / 100) * total;
      total += (Number(d.item_tax_per) / 100) * total;
      return sum + total;
    }, 0)
    : data?.total_amount || 0;

  const columns = isIndividual
    ? [
      { title: "NO.", render: (_, __, index) => index + 1, width: 40 },
      {
        title: "Item Name",
        render: (_, record) => (
          <>
            <div>{record.item_name}</div>
            {record.batch_name && (
              <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>
                Batch: {record.batch_name}
              </div>
            )}
          </>
        ),
      },
      {
        title: "Rate",
        dataIndex: "pur_r_rate",
        align: "right",
        render: (v) => Number(v).toFixed(2),
      },
      { title: "Per", dataIndex: "unit_name", align: "right" },
      { title: "Pur Return QTY", dataIndex: "pur_r_qty", align: "right" },
      { title: "Discount%", dataIndex: "item_discount_per", align: "right", render: (v) => Number(v).toFixed(2).replace(/\.00$/, "") },

      ...(!isGSTDisabled
        ? [
          { title: `${taxLabel} `, dataIndex: "item_tax_per", align: "right", render: (v) => Number(v).toFixed(2).replace(/\.00$/, "") },
        ]
        : []),

      {
        title: "Total",
        align: "right",
        render: (_, d) => {
          let qty = d.pur_r_qty || 0;
          let rate = Number(d.pur_r_rate || 0);
          let total = qty * rate;
          total -= (Number(d.item_discount_per) / 100) * total;
          total += (Number(d.item_tax_per) / 100) * total;
          return total.toFixed(2);
        },
      },
    ]
    : [
      { title: "NO.", render: (_, __, index) => index + 1, width: 40 },
      {
        title: "Item Name",
        render: (_, record) => (
          <>
            <div>{record.item_name}</div>
            {record.batch_name && (
              <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>
                Batch: {record.batch_name}
              </div>
            )}
          </>
        ),
      },
      {
        title: "Rate",
        dataIndex: "item_rate",
        align: "right",
        render: (v) => Number(v).toFixed(2),
      },
      { title: "Per", dataIndex: "per_unit_symbol", align: "right" },
      { title: "Quantity", dataIndex: "qty_display", align: "right" },
      // { title: "Sold Quantity", dataIndex: "done_qty_display", align: "right" },
      {
        title: "Amount",
        dataIndex: "item_total",
        align: "right",
        render: (v) => Number(v).toFixed(2),
      },
    ];

  return (
    <div className="voucher-section invoice-v2">
      {/* Header */}

      <Row justify="space-between" align="top" className="invoice-header">

        <Col flex="0 0 320px" className="bill-to" style={{ marginTop: "45px" }}>
          <Text strong>Supplier/ Creditor Code: &nbsp;{data.acc_code}</Text>
          <br />
          <Text strong>Name: &nbsp;{data.acc_name}</Text>
          {/* <br />
          <Text >Institution: &nbsp;{data.institution_name}</Text> */}
          <br />
          <Text className="wrap-text">Address: &nbsp; {data.address}</Text>

          <Text>Contact No: &nbsp; +{data.contact_no}</Text>
        </Col>
        <Col className="invoice-title">
          <Title level={2}>PURCHASE RETURN</Title>
          <Text strong>Voucher No: {data.pur_r_voucher_no}</Text>
          <br />
          <Text>Expense Date: {formatToCompanyTimezone(data.created_date)?.split(" ")[0]}</Text>
          <br />
          <Text>Expense By: {data.full_name?.split(" ")[0]}</Text>
          <br />
          <Text className="wrap-text">Address : {institution?.street_address}</Text>
          {institution?.phone_no && <Text>Contact No : &nbsp; +{institution?.phone_no}</Text>}
          <br />
          {institution?.vat_license && <><Text>
            {institution?.country?.trim().toLowerCase() === "united arab emirates"
              ? "TRN No: "
              : "Tax Reg No: "}{" "}
            {institution?.vat_license}
          </Text><br /></>}
          {data.licence_no && <Text>License No : {data.licence_no}</Text>}
        </Col>
      </Row>


      {/* Items Table */}
      <Table
        className="invoice-items"
        dataSource={items}
        columns={columns}
        pagination={false}
        rowKey="pur_r_id"
        size="small"
        summary={() => {
          if (isIndividual) {
            return (
              <Table.Summary.Row>
                {/* <Table.Summary.Cell colSpan={5} align="right">
                  <b>Grand Total</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  <b>{grandTotal.toFixed(2)}</b>
                </Table.Summary.Cell> */}
              </Table.Summary.Row>
            );
          }
          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={4} align="right">
                  Subtotal
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {Number(data.sub_total || 0).toFixed(2)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={4} align="right">
                  Discount Amount
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {Number(data.total_discount || 0).toFixed(2)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
              {isIndiaGst ? (
                <>

                  {data.place_of_supply_type == 'intra' && isIndiaGst && <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell colSpan={4} align="right">
                        CGST
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        {numberFormat(data.cgst_amount)}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>

                    <Table.Summary.Row>
                      <Table.Summary.Cell colSpan={4} align="right">
                        SGST
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        {numberFormat(data.sgst_amount)}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>}

                  {data.place_of_supply_type == 'inter' && isIndiaGst && <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell colSpan={4} align="right">
                        IGST
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        {numberFormat(data.igst_amount)}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>}

                  {data.gst_calculated == 'no' && <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell colSpan={4} align="right">
                        {taxLabel}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        {totalTax.toFixed(2)}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>}

                </>
              ) : (
                !isIndia && (
                  <Table.Summary.Row>
                    <Table.Summary.Cell colSpan={4} align="right">
                      {taxLabel}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">
                      {totalTax.toFixed(2)}
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                ))}

              {/* <Table.Summary.Row>
                <Table.Summary.Cell colSpan={3} align="right">
                  <b>Grand Total</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  <b>{Number(grandTotal).toFixed(2)}</b>
                </Table.Summary.Cell>
              </Table.Summary.Row> */}
            </>
          );
        }}
      />

      {/* Footer */}
      <Divider />
      <Row>
        <Col span={16}>
          {/* <Text>Invoice Due : {numberFormat(data.due_total || 0)}</Text>
    <br />
    <Text>
      Current Customer Due : {numberFormat(data.due_amount || 0)}
    </Text> */}
          {/* 🔽 Payment Breakdown */}
          {!printMode && data?.trans && data.trans.length > 0 && (
            <Row gutter={[16, 8]} style={{ marginTop: 12 }}>
              <Col span={10}>
                <Divider orientation="left" plain style={{ margin: "8px 0" }}>
                  Payment Breakdown
                </Divider>
                <Table
                  size="small"
                  bordered
                  pagination={false}
                  style={{ width: "100%" }}  // ✅ take full col width
                  rowKey={(_, index) => index}
                  dataSource={data.trans.map((tran, index) => ({
                    key: index,
                    index: index + 1,
                    account: tran.to_acc_name || "N/A",
                    amount:
                      data?.conversion_rate && data.conversion_rate !== 0
                        ? Big(tran?.tran_amount || 0).times(data?.conversion_rate || 1).toFixed(2)
                        : Big(tran.tran_amount).toFixed(2),
                  }))}
                  columns={[
                    {
                      title: "#",
                      dataIndex: "index",
                      width: 50,
                    },
                    {
                      title: "Cash / Account",
                      dataIndex: "account",
                      // ellipsis: true,
                      onCell: () => ({
                        style: { minWidth: 120 },   // ✅ enforce minWidth
                      }),
                    },
                    {
                      title: "Amount",
                      dataIndex: "amount",
                      align: "right",
                      width: 120,
                      render: (val) => numberFormat(val),
                    },
                  ]}

                />
              </Col>
              <Col span={2}></Col>
            </Row>
          )}
        </Col>

        <Col span={8} style={{ textAlign: "right" }}>
          <div>
            {/* Quantity */}
            <div style={{ display: "flex", textAlign: "left" }}>
              <Text>Quantity Total :</Text>
              <Text>
                ({items.reduce((sum, d) => sum + (Number(d.pur_r_qty) || 0), 0)})
              </Text>
            </div>

            {/* Sub Total */}
            {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Text>Sub Total : </Text>
        <Text>{numberFormat(isIndividual ? grandTotal : data.sub_total || 0)}</Text>
      </div> */}

            {/* Grand Total */}
            <div
              style={{
                borderTop: "1px solid #000",
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 4,
                marginTop: 4,
              }}
            >
              <Text strong>Grand Total : {institution?.currency}</Text>
              <Text strong>{numberFormat(grandTotal)}</Text>
            </div>

            {/* Paid */}
            <div
              style={{
                borderTop: "1px solid #000",
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 4,
                marginTop: 4,
              }}
            >
              <Text strong>Paid : {institution?.currency}</Text>
              <Text strong>{numberFormat(data.paid_amount || 0)}</Text>
            </div>

            {/* Due */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 2,
              }}
            >
              <Text strong>Due : {institution?.currency}</Text>
              <Text strong>{numberFormat(data.due_total || 0)}</Text>
            </div>
          </div>
        </Col>
      </Row>

      <Divider />
      <Row>
        <Col span={24}>
          <Text>
            In Word of Grand Total :{" "}
            {convertNumberToWords(grandTotal, data?.currency || institution?.currency)}
          </Text>
          <br />
          <Text>Description : {data.narration || "-"}</Text>
        </Col>
      </Row>

      {(showStamp || showSignature) && (
        <div className="invoice-footer-section">
          <div className="footer-right-group">
            {showStamp && institution?.stamp && (
              <div className="stamp-block">
                <img src={institution.stamp} alt="Stamp" />
              </div>
            )}

            {showSignature && institution?.signature && (
              <div className="signature-block">
                <img src={institution.signature} alt="Signature" />
                <div className="sign-line-text">Authorized Signature</div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchaseReturnVoucherBody;
